import { useFormMethods } from '../../../../../helpers/formManager';
import { useEvent } from '../../../../../hooks/useEvent';

export const useSyncClassicTimes = (getFn) => {
  const { getValues, setValue } = useFormMethods();

  return useEvent((duration) => {
    const { startName, endName, controller } = getFn();

    if (!duration) {
      setValue(startName, null);
      setValue(endName, null);
      return;
    }

    const [prevFrom, prevTo] = getValues([startName, endName]);

    const nextTimes = controller.syncTimes({ duration, prevFrom, prevTo });

    setValue(startName, nextTimes.from);
    setValue(endName, nextTimes.to);
  });
};
